<template>
    <div class="d-flex">
        <div ref="recaptcha" class="g-recaptcha" :data-sitekey="siteKey"></div>
    </div>
 </template>
 
 <script setup>
    import {onMounted, ref} from "vue";
    import { siteKey } from "@/mixins/Helpers";

    const recaptcha = ref(null);

    onMounted(() => {
        initRecaptcha()
    })

    function initRecaptcha() {
        if (!siteKey.value) {
            setTimeout(initRecaptcha, 500);
            return;
        }
        
        if (window.grecaptcha) {
            window.grecaptcha.render(recaptcha.value, {
            sitekey: siteKey.value,
            });
        } else {
            setTimeout(initRecaptcha, 500);
        }
    }
 </script>
 
 <style scoped>
 .btn_class{
   border-radius: '8px';
 }
 </style>